import { UserRole } from '@stores/member';

export const RESOURCE_TYPES = {
  SOURCE: 'source',
  DESTINATION: 'destination',
  TRANSFORMATION: 'transformation',
};

export const DIRECTORY_TABS = {
  ALL_SOURCES: 'All Sources',
  EVENT_STREAMS: 'Event Streams',
  CLOUD_EXTRACT: 'Cloud Extract',
  WAREHOUSE_ACTIONS: 'Reverse ETL',
  POPULAR_SOURCE: 'Popular',
  DESTINATIONS: 'Destinations',
  WAREHOUSE_DESTINATIONS: 'Warehouse Destinations',
  CLOUD_DESTINATIONS: 'Cloud Destinations',
  POPULAR_DESTINATION: 'Popular',
};

export const SOURCE_CATEGORIES = {
  CLOUD: 'cloud',
  SINGER: 'singer-protocol',
  WAREHOUSE: 'warehouse',
};

export const DESTINATION_CATEGORIES = {
  WAREHOUSE: 'warehouse',
};

export const USER_ROLES: { value: UserRole; label: string; level: number }[] = [
  {
    value: 'admin',
    label: 'Admin',
    level: 300,
  },
  {
    value: 'read-write',
    label: 'Read-Write',
    level: 200,
  },
  {
    value: 'member',
    label: 'Read-Only',
    level: 100,
  },
];

const NameRegex = '^[A-Za-z-_. 0-9]{2,50}$';
const DescriptionRegex = '^[A-Za-z-_. 0-9]{2,200}$';
export const REGEX_STRING = {
  SOURCE_NAME: NameRegex,
  MODEL_NAME: NameRegex,
  MODEL_DESCRIPTION: DescriptionRegex,
  DESTINATION_NAME: NameRegex,
  TRANSFORMATION_NAME: NameRegex,
  TRANSFORMATION_DESCRIPTION: DescriptionRegex,
  LIBRARY_NAME: NameRegex,
  LIBRARY_DESCRIPTION: DescriptionRegex,
  EMAIL: '^[^\\s@]+@[^\\s@]+.[^\\s@]+$',
  TOKEN_NAME: '^[0-9a-zA-Z_ -]{1,64}$',
  ORGANIZATION_NAME: '^[A-Za-z-_. 0-9]{2,50}$',
  WORKSPACE_NAME: '^[A-Za-z-_.+ 0-9]{2,50}$',
  USER_NAME: "^[0-9A-Za-z ,.'-]{1,50}$",
};

export const URLS = {
  TERMS_OF_SERVICE: 'https://rudderstack.com/master-service-agreement',
  PRIVACY_POLICY: 'https://rudderstack.com/privacy-policy',
  PRICING: 'https://rudderstack.com/pricing',
  DOCS: 'https://docs.rudderstack.com',
  FEEDBACK: 'https://rudderstack.canny.io/feature-requests',
  ADD_TRANSFORMATION: 'https://rudderstack.com/docs/transformations/#adding-a-transformation',
  ACCESS_TOKEN: 'https://rudderstack.com/docs/transformations/api-access-token/',
  API: 'https://docs.rudderstack.com/rudderstack-api',
  SAMPLE_TRANSFORMATIONS: 'https://github.com/rudderlabs/sample-user-transformers',
  SLACK_INVITE:
    'https://join.slack.com/t/rudderstack/shared_invite/zt-z276dtg4-vbwl5gK5gVytnkOEi0C7Sg',
  VIDEO_LIBRARY: 'https://www.youtube.com/channel/UCgV-B77bV_-LOmKYHw8jvBw',
  TRACKING_PLAN_DOCS: 'https://www.rudderstack.com/docs/data-governance/tracking-plans/',
  RUDDERSTACK_OVERVIEW: 'https://www.youtube.com/watch?v=vOaw9pKn6_M',
  CUSTOMER_METRICS:
    'https://www.rudderstack.com/blog/a-guide-to-customer-metrics-what-to-track-and-why',
  DESTINATION_DOCS: 'https://www.rudderstack.com/docs/dashboard-guides/destinations/',
};

export const MESSAGES = {
  NON_ADMIN: 'You don’t have permission to perform this action. Please contact your admin',
};

export const SESSION_STORAGE_KEYS = {
  source: 'OauthMetadata',
  destination: 'DestOauthMetadata',
};
